import { Configuration, PaymentsApi } from '@/api';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const useGetPaymentProviderStatusQuery = () => {
  const queryClient = useQueryClient();

  const paymentsApi = new PaymentsApi(new Configuration(useAuth));

  const queryKey = ['payment-provider-status'];

  const {
    isLoading,
    isFetching,
    data: status,
    error,
  } = useQuery({
    queryKey,
    queryFn: () => paymentsApi.getPaymentProviderStatus(),
  });

  const invalidateQuery = async () => {
    await queryClient.invalidateQueries({ queryKey });
  };

  return {
    status,
    isLoading,
    isFetching,
    error,
    invalidateQuery,
  };
};

export default useGetPaymentProviderStatusQuery;
